module.exports = __webpack_public_path__ + "img/vmc_aniv4_24Aug2021.1846c412.jpg";